import Image from "next/image";
import { cn } from "@/lib/cn";
import { isOptimisableImageUrl } from "@/lib/images";

const FILL_CLASSES = "absolute inset-0 h-full w-full object-cover";

type Common = {
  src: string;
  alt?: string;
  className?: string;
  priority?: boolean;
  onError?: () => void;
};

type Props = Common &
  (
    | { sizes: string; width?: never; height?: never }
    | { width: number; height: number; sizes?: never }
  );

export function RemoteImage({
  src,
  alt = "",
  sizes,
  width,
  height,
  className,
  priority = false,
  onError,
}: Props) {
  if (!isOptimisableImageUrl(src)) {
    return (
      <img
        src={src}
        alt={alt}
        loading={priority ? "eager" : "lazy"}
        onError={onError}
        className={cn(FILL_CLASSES, className)}
      />
    );
  }

  if (width !== undefined && height !== undefined) {
    return (
      <Image
        src={src}
        alt={alt}
        width={width}
        height={height}
        priority={priority}
        onError={onError}
        className={cn(FILL_CLASSES, className)}
      />
    );
  }

  return (
    <Image
      src={src}
      alt={alt}
      fill
      sizes={sizes}
      priority={priority}
      onError={onError}
      className={cn("object-cover", className)}
    />
  );
}
